export default __webpack_public_path__ + "static/solidified-remains-1080-957bb5964e7bd52dc74ad98a5a07125c.mp4";